import React from 'react';
import classNames from 'classnames';
import Scrollable from 'general/js/scrollable';
import LeaderboardTable from '../components/leaderboard-table';
import { viewTypes } from '../enums';

class LeaderboardTableWrapper extends React.Component {
    constructor(props) {
        super(props);
        this.rootRef = React.createRef();
        this.wrapperRef = React.createRef();
    }

    componentDidMount() {
        this.scrollable = new Scrollable(
            this.rootRef.current,
            this.wrapperRef.current,
        );
    }

    componentDidUpdate() {
        if (this.scrollable) {
            this.scrollable.update();
        }
    }

    componentWillUnmount() {
        if (this.scrollable) {
            this.scrollable.destroy();
        }
    }

    getViewState = () => {
        const { view } = this.props;

        let viewState = '';

        switch (view) {
            case viewTypes.HOLE_BY_HOLE:
                viewState = 'leaderboard__table-wrapper--hole-by-hole';
                break;
            case viewTypes.R_SCORE:
                viewState = 'leaderboard__table-wrapper--r-score';
                break;
            default:
                viewState = '';
        }

        return viewState;
    };

    render() {
        const {
            favoriteState,
            isPlayOffMode,
            view,
            liveScanner,
            ...rest
        } = this.props;

        const tableWrapperStateCss = classNames({
            'is-play-off': isPlayOffMode,
            'is-favorite-state': view !== viewTypes.HOLE_BY_HOLE && favoriteState,
        });

        return (
            <div
                className={'leaderboard__table-container'}
                ref={this.rootRef}
            >
                <div
                    className={`leaderboard__table-wrapper ${this.getViewState()} ${tableWrapperStateCss}`}
                    ref={this.wrapperRef}
                >
                    <LeaderboardTable
                        {...rest}
                        view={view}
                        isPlayOffMode={isPlayOffMode}
                        favoriteState={favoriteState}
                        liveScanner={liveScanner}
                    />
                </div>
            </div>
        );
    }
}

export default LeaderboardTableWrapper;
